import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { faEye } from '@fortawesome/free-solid-svg-icons'
import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons'
import { faCamera } from '@fortawesome/free-solid-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import {faHouseChimney} from '@fortawesome/free-solid-svg-icons'
import {faXmark} from '@fortawesome/free-solid-svg-icons'
import {faAddressCard} from '@fortawesome/free-solid-svg-icons'
import {faGear} from '@fortawesome/free-solid-svg-icons'
import {faPowerOff} from '@fortawesome/free-solid-svg-icons'
import {faIdCard} from '@fortawesome/free-solid-svg-icons'
import {faCoins} from '@fortawesome/free-solid-svg-icons'
import {faMoneyCheckDollar} from '@fortawesome/free-solid-svg-icons'
import {faGlobe} from '@fortawesome/free-solid-svg-icons'
import {faPhone} from '@fortawesome/free-solid-svg-icons'
import { faPrint } from '@fortawesome/free-solid-svg-icons'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { faFileArrowDown } from '@fortawesome/free-solid-svg-icons'
import { faApple } from '@fortawesome/free-brands-svg-icons'
import { faGooglePlay } from '@fortawesome/free-brands-svg-icons'
import { faInbox } from '@fortawesome/free-solid-svg-icons'
import { faBook } from '@fortawesome/free-solid-svg-icons'
import { faTicketSimple } from '@fortawesome/free-solid-svg-icons'
import { faScroll } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faUserSecret)
library.add(faEyeSlash)
library.add(faEye)
library.add(faRightFromBracket)
library.add(faCamera)
library.add(faEnvelope)
library.add(faWhatsapp)
library.add(faHouseChimney)
library.add(faBars)
library.add(faXmark)
library.add(faBars)
library.add(faGear)
library.add(faPowerOff)
library.add(faIdCard)
library.add(faCoins)
library.add(faMoneyCheckDollar)
library.add(faGlobe)
library.add(faPhone)
library.add(faPrint)
library.add(faDownload)
library.add(faAddressCard)
library.add(faUser)
library.add(faFileArrowDown)
library.add(faApple)
library.add(faGooglePlay)
library.add(faInbox)
library.add(faBook)
library.add(faTicketSimple)
library.add(faScroll)
export { FontAwesomeIcon }
